import clsx from "clsx";

import { FieldLabel } from "./FieldLabel";
import { View } from ".";

type SwitchOption = {
  label: string;
  value: string | null;
  isCategory?: boolean;
  category?: string;
};

type SwitchProps = {
  className?: string;
  label?: string;
  labelClassName?: string;
  options: SwitchOption[];
  value?: string | null;
  onChange?: (value: string | null) => void;
  error?: string;
  isDisabled?: boolean;
  tooltip?: string;
};

export const Switch = ({ className, label, options, value, onChange = () => {}, labelClassName, error, isDisabled = false, tooltip }: SwitchProps) => {
  const onChangeInternal = (newValue: string | null) => {
    if (isDisabled) return;

    onChange(newValue);
  };

  return (
    <FieldLabel
      label={label}
      className={labelClassName}
      error={error}
      tooltip={tooltip}
    >
      <View
        className={clsx(
          "flex rounded-lg p-1 !h-[40px]",
          {
            "bg-gray-100 dark:bg-gray-800/60": !error,
            "bg-red-50 dark:bg-red-950/30 ring-1 ring-error": error,
          },
          className,
        )}
      >
        {options.map((option) => (
          <button
            key={option.value}
            className={clsx("flex-1 flex items-center justify-center py-1.5 px-4 text-sm font-medium rounded-md transition-all duration-200", {
              "bg-white dark:bg-gray-700 text-gray-900 dark:text-white shadow-sm": value === option.value,
              "text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300": value !== option.value,
              "opacity-50 cursor-not-allowed": isDisabled,
            })}
            onClick={() => onChangeInternal(option.value)}
          >
            {option.label}
          </button>
        ))}
      </View>
    </FieldLabel>
  );
};
